import React, { Component } from 'react';
import { Button, Form, Grid, Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

class AccountInfo extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        };
    }

    render() {
        const { username, accountMail, editAccountMailFlag } = this.props;
        return (
            <div>
                <Table celled size="small" unstackable compact>
                    <Table.Body>
                        <Table.Row>
                            <Table.Cell textAlign="right" verticalAlign="middle">
                                <strong><FormattedMessage id="common.username" /></strong>
                            </Table.Cell>
                            <Table.Cell>
                                <Grid>
                                    <Grid.Column width={8} verticalAlign="middle" >
                                        { username }
                                    </Grid.Column>
                                </Grid>
                            </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                            <Table.Cell textAlign="right" verticalAlign="middle">
                                <strong><FormattedMessage id="common.accountMail" /></strong>
                            </Table.Cell>
                            <Table.Cell verticalAlign="middle">
                                {(editAccountMailFlag) ?
                                    <Form size="mini">
                                        <Grid columns={2} stackable verticalAlign="middle">
                                            <Grid.Column width={13} verticalAlign="middle">
                                                <Form.Field >
                                                    <input
                                                        placeholder="Unesite e-mail"
                                                        defaultValue={accountMail}
                                                        value={this.state.accountMail}
                                                        onChange={(e) => this.setState({ accountMail: e.target.value })}
                                                        name="input"
                                                    />

                                                </Form.Field>
                                            </Grid.Column>
                                            <Grid.Column width={1} verticalAlign="middle">
                                                <Form.Field >
                                                    <Button
                                                        compact
                                                        circular
                                                        floated="right"
                                                        icon="check"
                                                        size="mini"
                                                        basic="true"
                                                        color="blue"
                                                        onClick={() => this.props.editAccountMail(this.state.accountMail)}
                                                    />
                                                </Form.Field>
                                            </Grid.Column>
                                        </Grid>
                                    </Form>
                                    : accountMail
                                }
                            </Table.Cell>
                        </Table.Row>
                    </Table.Body>
                </Table>
            </div>
        );
    }
}

export default AccountInfo;



// WEBPACK FOOTER //
// ./src/views/StudentPersonalInfo/AccountInfo.js